import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Herosection from "./Components/Herosection/Herosection";
import ForgotPassword from "./Components/ForgotPassword/ForgotPassword";
import Cart from './Components/Addtocart/Cart';
import Product from './Components/ProductOverview/Product';
import Preloader from './Preloader.jsx';
import Checkout from './Components/Checkoutpage/Checkout';
import OrderPlaced from "./Components/Checkoutpage/OrderPlaced";
import Register from './Components/Signuppage/Register.js';
import Profile from './Components/UserProfile/Profile';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import KukuNamkeen from './Components/ProductsList/KukuNamkeen';
import Sweets from './Components/ProductsList/Sweets';
import CategoryProductsPage from './Components/ProductsList/CategoryProductsPage.jsx';
import Header from './Components/Header/Header';
import About from './Components/StaticPages/Aboutuspage/About';
import Contact from './Components/StaticPages/ContactUsPage/Contact';
import Faq from './Components/StaticPages/Faqpage/Faq';
import TermConditions from './Components/StaticPages/TermConditions';
import PrivacyPolicy from './Components/StaticPages/PrivacyPolicy';
import ReturnRefund from './Components/StaticPages/ReturnRefund';
import StaticPage from './Components/StaticPages/Static-page';
import Footer from './Components/Footer/Footer';
import LoginRequiredModal from './Components/Loginpage/LoginRequiredModal';
import ResetPassword from './Components/ResetPassword/ResetPassword';
import PlacedOrder from './Components/PlacedOrder/PlacedOrder';
import EnterOTP from './Components/ResetPassword/EnterOTP';
import StaticPages from './Components/StaticPages/StaticPage/StaticPage.jsx';
import Payment from './Components/Payment/Payment.js';
import PaymentError from './Components/Payment/PaymentError.js';
import Makingprocess from './Components/StaticPages/MakingProcess/Makingprocess.jsx';
import { Helmet } from "react-helmet";
import NotFound from './Components/NotFound/NotFound.jsx';
import WhatsAppButton from './utils/WhatsAppButton.js';
import BecomeDistributor from './Components/StaticPages/BecomeDistributor/BecomeDistributor';
import CorporateGifting from './Components/StaticPages/CorporateGifting/CorporateGifting.jsx';
import TrackOrders from './Components/TrackOrder/TrackOrders.jsx';
import BlogsPage from './Components/Blogs/BlogsPage.jsx';
import BlogDetailsPage from './Components/Blogs/BlogDetailsPage.jsx';
import { captureFbclid } from './utils/metaPixel.js';
import { useUtmTracker } from './hooks/useUtmTracker';
import './Components/PageHeader/PageHeader.css';

function UtmTrackerListener() {
  useUtmTracker();
  return null;
}

function RouteScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    captureFbclid();
  }, []);

  const isComingSoon = process.env.REACT_APP_COMING_SOON === "true";
  console.log(
    isComingSoon
  );
  useEffect(() => {
    if (isComingSoon) {
      document.body.classList.add("coming-soon-mode");
    } else {
      document.body.classList.remove("coming-soon-mode");
    }
  }, [isComingSoon]);


  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
          },
        },
      })
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, []);


  if (isComingSoon) {
    return (
      <div className="coming-soon-container">

        <img src="/KUKU_LOGO-removebg.png" alt="Kuku Namkeen Logo" className="logo" />

        <h1>Coming Soon</h1>
        <p>Our delicious snacks & sweets are launching soon. Stay connected!</p>

        <div className="social-icons">
          <a
            href="https://www.linkedin.com/in/kuku-namkeen-234313291?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>

          <a
            href="https://instagram.com/kuku_namkeen?igshid=MzMyNGUyNmU2YQ=="
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>

          <a
            href="https://www.facebook.com/profile.php?id=100095135198975&mibextid=ZbWKwL"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-facebook"></i>
          </a>
        </div>

        <div className="contact-icons">
          <a href="tel:+919427265661">
            <i className="fas fa-phone"></i>
          </a>

          <a
            href="https://api.whatsapp.com/send/?phone=919427265661&text=we%20want%20to%20inquiry%20for%20Kuku%20Products"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>

      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Helmet>
        {/* Google Tag Manager */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-VY1YL2WN1S"></script>
        <script type="text/javascript">
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-VY1YL2WN1S');
      `}
        </script>

        {/* Microsoft Clarity */}
        <script type="text/javascript">
          {`
        (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "mdcd40ib4r");
      `}
        </script>

        {/* Facebook Pixel */}
        <script type="text/javascript">
          {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '436687482634111');
        fbq('track', 'PageView');
      `}
        </script>
        <noscript>
          {`
                        <img height="1" width="1" style="display:none"
                             src="https://www.facebook.com/tr?id=436687482634111&ev=PageView&noscript=1" />
                    `}
        </noscript>
      </Helmet>
      <div>
        {loading ? (
          <Preloader />
        ) : (
          <BrowserRouter>
            <UtmTrackerListener />
            <RouteScrollToTop />
            <WhatsAppButton />
            <LoginRequiredModal />
            {/* <ScrollToTop /> */}
            <Header />
            <Routes>
              <Route path="/login" element={<Register />} />
              <Route path="/sign-up" element={<Register />} />
              {/* <Route path="/login" element={<Login />} />
            <Route path="/sign-up" element={<Signup />} /> */}
              <Route path="/register" element={<Register />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/enterotp" element={<EnterOTP />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="/" element={<Herosection />} />
              <Route path="/add-to-cart" element={<Cart />} />
              <Route path='/product/:slug' element={<Product />} />
              <Route path="/categories" element={<Sweets />} />
              <Route path="/categories/:categorySlug" element={<Sweets />} />
              <Route path="/sweets" element={<Sweets />} />
              <Route path="/kuku-namkeen" element={<KukuNamkeen />} />
              <Route path="/category/:categoryId" element={<CategoryProductsPage />} />
              <Route path='/checkout' element={<Checkout />} />
              <Route path='/payment-success/:id' element={<OrderPlaced />} />
              <Route path='/payment-error' element={<PaymentError />} />
              <Route path='/orders' element={<PlacedOrder />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/makingprocess" element={<Makingprocess />} />
              <Route path="/about" element={<About />} />
              <Route path="/become-distributor" element={<BecomeDistributor />} />
              <Route path="/corporate-gifting" element={<CorporateGifting />} />
              <Route path="/track-orders" element={<TrackOrders />} />
              <Route path="/blogs" element={<BlogsPage />} />
              <Route path="/blogs/:blogId" element={<BlogDetailsPage />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/static-page/:slug" element={<StaticPage />} />
              <Route path="/static-page/faq/" element={<Faq />} />
              <Route path="/staticpages/:slug" element={<StaticPages />} />

              {/* <Route path="/" element={<UnderConstruction />} /> */}


              <Route path="/terms-conditions" element={<TermConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/return-refund-policy" element={<ReturnRefund />} />
              <Route path="*" element={<NotFound />} />


            </Routes>

            <Footer />
          </BrowserRouter>
        )}
        {/* <ScrollToTopButton /> */}
      </div>
    </QueryClientProvider>
  );
}

export default App;
